import { FC, useContext, useState } from 'react';

import { Modal, Tabs, ITabOption, H2 } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import s from './WorkShiftDetails.module.scss';
import { WorkShiftEvents } from './WorkShiftEvents';
import { WorkShiftPayments } from './WorkShiftPayments';
import { WorkShiftReport } from './WorkShiftReport';

type TTab = 'REPORT' | 'EVENTS' | 'PAYMENTS';

interface IWorkShiftItemProps {
  workShiftId: number;
  close: () => void;
}

export const WorkShiftDetails: FC<IWorkShiftItemProps> = ({
  close,
  workShiftId,
}) => {
  const { t } = useContext(LocalizationContext);
  const TABS: Array<ITabOption<TTab>> = [
    { title: t('report'), value: 'REPORT' },
    { title: t('event'), value: 'EVENTS' },
    { title: t('payments'), value: 'PAYMENTS' },
  ];

  const [tab, setTab] = useState<TTab>('REPORT');

  return (
    <Modal onClose={close} className={s.container}>
      <H2 className={s.title}>{t('workShift')}</H2>
      <Tabs options={TABS} value={tab} onChange={setTab} className={s.tabs} />
      {tab === 'EVENTS' && <WorkShiftEvents workShiftId={workShiftId} />}
      {tab === 'REPORT' && <WorkShiftReport workShiftId={workShiftId} />}
      {tab === 'PAYMENTS' && <WorkShiftPayments workShiftId={workShiftId} />}
    </Modal>
  );
};
